import { cn } from '@/lib/utils';

/**
 * The one on/off switch look: a native `<input type="checkbox" role="switch">` drawn as a track and a knob, so it keeps
 * the checkbox's keyboard and form behaviour. The "Kết nối MCP" company switch, the "Chủ động" tab and "Hana của tôi"
 * share it, so they cannot drift. Off and disabled, it dims; the focus ring shows only for the keyboard.
 */
export const SWITCH = cn(
  'relative h-6 w-11 shrink-0 cursor-pointer appearance-none rounded-full bg-[hsl(var(--h-muted-foreground)/0.4)] transition-colors',
  'before:absolute before:top-0.5 before:left-0.5 before:size-5 before:rounded-full before:bg-[hsl(var(--h-card))] before:shadow-[var(--h-shadow-sm)] before:transition-transform',
  'checked:bg-[hsl(var(--h-primary))] checked:before:translate-x-5',
  'disabled:cursor-not-allowed disabled:opacity-50',
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[hsl(var(--h-primary))]',
);

/** The bordered row a switch sits in, its name and hint on the left. */
export const SWITCH_ROW = cn(
  'flex cursor-pointer items-center justify-between gap-4 rounded-[var(--h-radius-lg)] border border-[hsl(var(--h-border))] bg-[hsl(var(--h-muted)/0.35)] p-3',
  'has-[:disabled]:cursor-not-allowed',
);
